import { render } from "./FormButtonsItem.vue?vue&type=template&id=1185b181&scoped=true"
import script from "./FormButtonsItem.vue?vue&type=script&lang=js"
export * from "./FormButtonsItem.vue?vue&type=script&lang=js"

import "./FormButtonsItem.vue?vue&type=style&index=0&id=1185b181&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1185b181"]])

export default __exports__